<template>
  <div class="vue-language"></div>
</template>

<script>
  import SessionStorageHelper from '@/helpers/SessionStorageHelper';
  import { ELanguage } from '@ringana/configs';
  import LanguageHelper from '../../helpers/LanguageHelper';
  import CookieHelper from '../../helpers/OldCookieHelper';
  import CommonMethods from '../../methods/CommonMethods';
  import LanguageRedirectHelper from '../../helpers/LanguageRedirectHelper';
  import config from '../../../config';
  import FetchHelper from '../../helpers/OldFetchHelper';

  export default {
    data() {
      return {
        languages: [],
      };
    },
    mounted() {
      this.checkIfRedirectNeeded();
      // first component loaded setting cookie for A/B split
      if(CookieHelper.checkIfExternalCookieIsAccepted(`rin-version`, this.fetchSplitRunCookie)) {
        this.fetchSplitRunCookie();
      }
    },
    methods: {
      /**
       * checks if a redirect might be necessary based on the existence/absence of the languageswitch url param
       *
       * @return void
       */
      checkIfRedirectNeeded() {
        const languageSwitch = CommonMethods.getUrlParam(`languageswitch`);
        if(languageSwitch === `1` || languageSwitch === ``) {
          this.prepareRedirect();
        }
      },
      async fetchSplitRunCookie() {
        const fetchConfig = {
          path: `${config.api.paths.configs.basepath}${config.api.paths.configs.paths.splitrun}`,
        };
        await FetchHelper.get(fetchConfig);
      },
      /**
       * prepares the environment to handle the redirect based on the existence/absence of the rin-language cookie
       *
       * @return void
       */
      async prepareRedirect() {
        const browserLang = navigator.language || navigator.userLanguage; // navigator.userLanguage for IE11
        const browserLangIso = browserLang.split(`-`)[0];
        let currentLang = document.querySelector(`html`).getAttribute(`lang`);
        if(currentLang) {
          [currentLang] = currentLang.split(`-`);
        }

        const langCookie = CookieHelper.getLanguage();
        if(CookieHelper.checkIfCookiesCanBeSet()) {
          if(langCookie && langCookie !== currentLang) {
            this.redirect(langCookie);
          }
        } else {
          this.languages = await LanguageHelper.fetchLanguages();
          if(!!this.languages && this.languages.includes(browserLangIso)) {
            CookieHelper.setLanguage(browserLangIso);
            if(browserLangIso !== currentLang) {
              SessionStorageHelper.removeChristmasCalendarSeen(); // needed to preserve the christmas calendar (living in the AnnouncementBar.vue) when switching languages
              this.redirect(browserLangIso);
            }
          } else if(browserLangIso.toLowerCase() === `sr`) {
            // Special condition for serbian clients: if the browser language is serbian,
            // clients will be redirected to english version instead of German as default
            if(currentLang !== ELanguage.EN) {
              this.redirect(ELanguage.EN);
            }
          } else {
            CookieHelper.setLanguage(ELanguage.DE);
          }
        }
      },
      /**
       * finds the correct target URL based on the browser or cookie language
       *
       * @param browserIsoOrCookieValue {string} rin-language cookie or browser language in the format 'xx'
       *
       * @return void
       */
      redirect(browserIsoOrCookieValue) {
        /*
         * NodeLists and Arrays are two different things because NodeLists are actually not a JavaScript API, but a browser API.
         * Things like querySelectorAll() and getElementsByTagName() aren’t JavaScript methods, they’re browser APIs that let you access DOM elements.
         * You can then manipulate them with JavaScript.
         *
         * We need to convert the NodeList to an Array with Array.from
         * Polyfill for IE is already implemented, probably from the theme, could be found here
         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Polyfill
         */
        const alternateLanguageLinkNodes = Array.from(document.querySelectorAll(`link[rel=alternate][hreflang]`));
        const redirect = alternateLanguageLinkNodes.find(code => code.getAttribute(`hreflang`).split(`-`)[0] === browserIsoOrCookieValue);
        if(redirect) {
          window.location.replace(LanguageRedirectHelper.buildRedirectUrl(redirect.getAttribute(`href`).split(`?`)[0], browserIsoOrCookieValue));
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  .vue-language {
    display: none;
  }
</style>
